module.exports = __webpack_public_path__ + "img/banner1_4.015b1651.png";